import React, { useState, useEffect }  from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/esm/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
//import imgSrcMAC from './img/LOGOTIPO_HOSPITALES_MAC_1.png';
//import imgSrc4 from './img/nav_bar.jpeg';

// ****** DataTable
import 'datatables.net-dt/css/dataTables.dataTables.css';  // Estilos de DataTable
import 'datatables.net';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
// Bootstrap
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import 'bootstrap-icons/font/bootstrap-icons.css';


DataTable.use(DT);
const AprobacionSupervisor = ({usuario, apiUrl}) => {
    const [arrHoras, setArrHoras] = useState();
    const [estatusSelected, setEstatusSelected] = useState("");
    const [observaciones, setObservaciones] = useState("");
    // **** Modales
    const [idHoraSelected, setIdHoraSelected] = useState(0);
    const [nombreProyectoSelected, setNombreProyectoSelected] = useState(0);
    const [nombreEtapaSelected, setNombreEtapaSelected] = useState(0);
    const [nombreTareaSelected, setNombreTareaSelected] = useState(0);
    const [fechaSelected, setFechaSelected] = useState(0);
    const [horasSelected, setHorasSelected] = useState(0);
    const [actividadesSelected, setActividadesSelected] = useState(0);
    const [nombreColaborSelected, setNombreColaborSelected] = useState(0);
    const [estatusDeptoSelected, setEstatusDeptoSelected] = useState(0);
    const [observacionesSelected, setObservacionesSelected] = useState(0);
    const [fmodificacionSelected, setFmodificacionSelected] = useState(0);
    // -- Aprobación
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);

    const handleShowModal = (IDHORA, NOMBREPROYECTO, NOMBREETAPA, NOMBRETAREA, FECHA, HORAS, ACTIVIDAD, NOMBRECOLABORADOR, 
        ESTATUSDEPTO, OBSERVACIONES, FMODIFICACION, ESTATUS) => {
        setIdHoraSelected(IDHORA);
        setNombreProyectoSelected(NOMBREPROYECTO);
        setNombreEtapaSelected(NOMBREETAPA);
        setNombreTareaSelected(NOMBRETAREA);
        setFechaSelected(FECHA);
        setHorasSelected(HORAS);
        setActividadesSelected(ACTIVIDAD);
        setNombreColaborSelected(NOMBRECOLABORADOR);
        setEstatusDeptoSelected(ESTATUSDEPTO);
        setObservacionesSelected(OBSERVACIONES);
        setFmodificacionSelected(FMODIFICACION);
        setEstatusSelected(ESTATUS);
        setShowModal(true);
    }

    const obtenHorasColaborador = () => {
        //*/
        axios.post(`${apiUrl}/horaslaboradas/obtenHorasSupervisor?token=${sessionStorage.getItem('token')}`, 
            {
                idSupervisor: usuario.IDUSUARIO,
                idPerfil: usuario.idPerfil
            })
            .then((objResponse) => {
                setArrHoras(objResponse.data.response)
            })
            .catch((error) => {
                alert('hubo un error al recuperar las horas de tus colaboradores: ' + error.response.data)
            });
        //*/
    }

    useEffect(()=>{
        obtenHorasColaborador();
    }, [])

    const columns = [
        { data: 'IDHORA'},
        { data: 'NOMBRECOLABORADOR'},
        { data: 'NOMBREPROYECTO'},
        { data: 'FECHA'},
        { data: 'HORAS'},
        { data: 'ACTIVIDAD'},
        { data: 'ESTATUSSUPERVISOR'},
        { title: 'Opciones'},
        { data: 'NOMBRETAREA', visible: false },
        { data: 'NOMBREETAPA', visible: false },
        { data: 'OBSERVACIONES', visible: false },
    ];

    const languageOpt = {
        info: 'Mostrando página _PAGE_ de _PAGES_',
        infoFiltered: '(filtrados de un total de _MAX_ registros encontrados)',
        lengthMenu: 'Mostrando _MENU_ registros por página',
        zeroRecords: 'Cero registros encontrados con los filtros seleccionados',
        search: 'Buscar',
        infoEmpty: 'No se encontraron',
        emptyTable: 'Tabla vacía (sin registros)'
    }
    
    const options = {
        order: [[0, 'desc']], // Indica que la primera columna (índice 0) se ordene de manera descendente
        columnsDefs: [
            {
                //targets: 1, // Índice de la columna a la que le queremos dar ancho
                //width: '100%' // El ancho deseado para esa columna
            },
            {
                //targets: [9],
                //width: '100px',
            }
        ],
        language: languageOpt,
        responsive: true
    };

    const actualizarEstatusHora = () => {
        axios.post(`${apiUrl}/horaslaboradas/actualizarEstatusHorasSupervisor?token=${sessionStorage.getItem('token')}`,
            {
                idHora: idHoraSelected,
                observacionesEstatus: observaciones,
                estatusHorasLaboradas: estatusSelected,
                idUsuario: usuario.IDUSUARIO
            })
            .then((response) => {
                setShowModal(false);
                setObservaciones("");
                obtenHorasColaborador();
            })
            .catch((error)=>{
                alert("Hubo un error al intentar actualizar el estatus de la hora.");
            })
    }
    return(
        <div>
            <Modal show={showModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Está a punto de actualizar el estatus de la hora con id: <b><u>{idHoraSelected}</u></b> como  <b><u>{estatusSelected}</u></b>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped hover responsive>
                        <tbody>
                            <tr>
                                <td>idHora</td>
                                <td>{idHoraSelected}</td>
                            </tr>
                            <tr>
                                <td>Nombre usuario</td>
                                <td>{nombreColaborSelected}</td>
                            </tr>
                            <tr>
                                <td>Proyecto</td>
                                <td>{nombreProyectoSelected}</td>
                            </tr>
                            <tr>
                                <td>Etapa</td>
                                <td>{nombreEtapaSelected}</td>
                            </tr>
                            <tr>
                                <td>Tarea</td>
                                <td>{nombreTareaSelected}</td>
                            </tr>
                            <tr>
                                <td>Fecha</td>
                                <td>{fechaSelected}</td>
                            </tr>
                            <tr>
                                <td>Horas</td>
                                <td>{horasSelected}</td>
                            </tr>
                            <tr>
                                <td>Actividades</td>
                                <td>{actividadesSelected}</td>
                            </tr>
                            <tr>
                                <td>Estatus Departamento</td>
                                <td>{estatusDeptoSelected}</td>
                            </tr>
                            <tr>
                                <td>Observaciones</td>
                                <td>{observacionesSelected}</td>
                            </tr>
                            <tr>
                                <td>Fecha de modificación</td>
                                <td>{fmodificacionSelected}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Introduce las observaciones para la aprobación de las horas</Form.Label>
                        <Form.Control 
                            as="textarea" rows={3}
                            style={{ resize: 'none', marginTop: '1em'}} 
                            placeholder='Descripción de actividades' value={observaciones}
                            onChange={event=>{setObservaciones(event.target.value)}}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                    <Button variant={(estatusSelected ==='APROBADA') ? "success" : "danger" } onClick={actualizarEstatusHora}>
                        {(estatusSelected ==='APROBADA') ? "Guardar aprobación" : "Guardar rechazo" }
                    </Button>
                </Modal.Footer>
            </Modal>
            <h3 style={{textAlign: 'center'}}>APROBACIÓN DE HORAS SUPERVISOR</h3>
            <Container>
                <Row>
                    <Col>
                        <DataTable
                            columns={columns} 
                            data={arrHoras}  
                            className="display"
                            options={options}
                            responsive={true}
                            slots={{
                                7: (data, row) => (
                                    <div>
                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Aprobar</strong> horas del colaborador.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn btn-success btn-sm bi bi-check-circle-fill"
                                                style={{marginRight: '1em'}}
                                                onClick={ () => {
                                                    handleShowModal(row.IDHORA, row.NOMBREPROYECTO, row.NOMBREETAPA, row.NOMBRETAREA, 
                                                        row.FECHA, row.HORAS, row.ACTIVIDAD, row.NOMBRECOLABORADOR, 
                                                        row.ESTATUS_DEPTO, row.OBSERVACIONES, row.FMODIFICACION, "APROBADA");
                                                }}
                                                disabled={( row.ESTATUS_DEPTO === 'APROBADA') ? true : false}
                                            >
                                            </Button>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                            placement='top'
                                            overlay={
                                                <Tooltip>
                                                    <strong>Rechazar</strong> horas del colaborador.
                                                </Tooltip>
                                            }
                                        >
                                            <Button 
                                                className="btn btn-danger btn-sm bi bi-x-circle-fill"
                                                onClick={ () => {
                                                    handleShowModal(row.IDHORA, row.NOMBREPROYECTO, row.NOMBREETAPA, row.NOMBRETAREA, 
                                                        row.FECHA, row.HORAS, row.ACTIVIDAD, row.NOMBRECOLABORADOR, 
                                                        row.ESTATUS_DEPTO, row.OBSERVACIONES, row.FMODIFICACION, "RECHAZADA");
                                                }}
                                                disabled={(row.ESTATUS_DEPTO === 'APROBADA') ? true : false}
                                            >
                                            </Button>
                                        </OverlayTrigger>
                                    </div>
                                )
                            }}
                            >
                            <thead>
                                <tr>
                                    <th className="dt-orderable-asc">idHora</th>
                                    <th>Nombre colaborador</th>
                                    <th>Proyecto</th>
                                    <th>Fecha</th>
                                    <th>Cantidad de horas</th>
                                    <th>Actividades</th>
                                    <th>Estatus supervisor</th>
                                </tr>
                            </thead>
                        </DataTable>
                    </Col>
                </Row>
            </Container>
            
        </div>
    )
}

export default AprobacionSupervisor;